import React, { useState } from "react";
import InputCell from "../../all-forms/interview-assessment-form/InputCell";
import { ChildFormProps, FamilyDetails } from "../../../types/Form-types";

const DEFAULT_FAMILY_ROWS: FamilyDetails[] = [
  { relationship: "Father", name: "", occupation: "" },
  { relationship: "Mother", name: "", occupation: "" },
  { relationship: "Spouse", name: "", occupation: "" },
  { relationship: "Brothers/Sisters", name: "", occupation: "" },
  { relationship: "Children", name: "", occupation: "" },
];

interface FamilyProps extends ChildFormProps {
  handleError: (name: string) => void;
}

const FamilyDetailsForm = ({
  formData,
  setFormData,
  errors,
  handleError,
}: FamilyProps) => {
  const [rows, setRows] = useState<FamilyDetails[]>(DEFAULT_FAMILY_ROWS);

  const handleChange = (
    relationship: string,
    field: "name" | "occupation",
    value: string,
  ) => {
    setRows((prevRows) => {
      const updated = prevRows.map((item) =>
        item.relationship === relationship ? { ...item, [field]: value } : item,
      );

      const mapped = updated.filter(
        (row) => row.name !== "" || row.occupation !== "",
      );

      setFormData((prev: any) => ({ ...prev, family_details: mapped }));
      return updated;
    });
    // ✅ clear specific cell error
    handleError(`family_details.${relationship}.${field}`);
  };

  return (
    <div className="pt-3">
      <p className="form-section-title mb-3">Family Details</p>

      <div className="table-responsive mb-4">
        <table className="form-table">
          <thead>
            <tr>
              <th>Relationship</th>
              <th>Name</th>
              <th>Occupation</th>
            </tr>
          </thead>

          <tbody>
            {rows?.map((row, i) => {
              const errorMsg = errors?.find(
                (e: any) => e?.relationship === row.relationship,
              );

              // errors?.[i]?.[row.relationship as keyof FamilyDetails];
              return (
                <tr key={i}>
                  <td className="text-center">{row.relationship}</td>
                  <InputCell
                    value={row.name}
                    name={"name"}
                    handleChange={(val: any) =>
                      handleChange(row.relationship, "name", val)
                    }
                    errorMessage={errorMsg?.name}
                  />

                  <InputCell
                    value={row.occupation}
                    name={"occupation"}
                    handleChange={(val: any) =>
                      handleChange(row.relationship, "occupation", val)
                    }
                    errorMessage={errorMsg?.occupation}
                  />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default FamilyDetailsForm;

// const handleChange = (
//   relationship: string,
//   field: "name" | "occupation",
//   value: string,
// ) => {
//   const updated = formData?.family_details?.map((item) =>
//     item.relationship === relationship ? { ...item, [field]: value } : item,
//   );

//   setFormData((prev) => ({
//     ...prev,
//     family_details: updated,
//   }));
// };
